import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import globalSettingsBranches from '../../../../../stores/global-settings-branches';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { Button } from 'primereact/button';
import { FilterExpanderWithListOfCheckboxes } from '../../../../../components/CustomExpander/componenets/filter-expander-with-list-of-checkboxes';
import { ProfessorCourseFeedbacksFilterType } from './professor-course-feedbacks-filter.type';
import { Dropdown } from 'primereact/dropdown';
import { CustomExpander } from '../../../../../components/CustomExpander/CustomExpander';

interface ProfessorCourseFeedbacksSideBarFilterProps {
  onSearch: (filters: ProfessorCourseFeedbacksFilterType) => void;
}

export const ProfessorCourseFeedbacksSideBarFilter: React.FC<ProfessorCourseFeedbacksSideBarFilterProps> =
  observer(({ onSearch }) => {
    const [selectedBranchIds, setSelectedBranchIds] = useState<number[]>([]);
    const [selectedAbstractCourseId, setSelectedAbstractCourseId] = useState<
      number | null
    >(null);
    const [selectedPollId, setSelectedPollId] = useState<number | null>(null);

    const handleSearch = () => {
      const filters: ProfessorCourseFeedbacksFilterType = {
        branchIds: selectedBranchIds,
        abstractCourseId: selectedAbstractCourseId,
        settingsAbstractPollId: selectedPollId,
      };
      onSearch(filters);
    };

    const styles = {
      container: {
        height: '100%',
        background: 'white',
        borderRadius: '8px',
        padding: '16px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column' as const,
      },
      header: {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        marginBottom: '16px',
        color: '#333',
      },
      content: {
        flex: 1,
        overflowY: 'auto' as const,
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '8px',
        paddingRight: '4px',
      },
      dropdownContainer: {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: '8px',
        padding: '8px',
      },
      dropdownLabel: {
        fontSize: '0.9rem',
        color: '#666',
      },
      buttonContainer: {
        marginTop: '16px',
        padding: '8px',
        borderTop: '1px solid #e9ecef',
      },
      searchButton: {
        width: '100%',
        backgroundColor: '#2196F3',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '12px',
        fontSize: '1rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
      },
    };

    return (
      <div style={styles.container}>
        <div style={styles.header}>סינונים</div>
        <div style={styles.content}>
          <FilterExpanderWithListOfCheckboxes
            title="שלוחות"
            items={globalSettingsBranches.branches}
            selectedItems={selectedBranchIds}
            onItemToggle={(branchId) => {
              setSelectedBranchIds((prev) =>
                prev.includes(branchId)
                  ? prev.filter((b) => b !== branchId)
                  : [...prev, branchId],
              );
            }}
            getItemLabel={(branch) => branch.branchName}
            getItemKey={(branch) => branch.id}
            defaultExpanded={true}
            searchPlaceholder="חפש שלוחה..."
          />

          <CustomExpander>
            <div>קורס טיפוסי</div>
            <div style={styles.dropdownContainer}>
              <Dropdown
                value={selectedAbstractCourseId}
                options={globalSettingsStores.abstractCourses}
                onChange={(e) => setSelectedAbstractCourseId(e.value)}
                optionLabel="courseName"
                optionValue="id"
                placeholder="בחר קורס טיפוסי"
                showClear
                filter
                filterPlaceholder="חפש קורס..."
                style={{
                  width: '100%',
                  direction: 'rtl',
                }}
              />
            </div>
          </CustomExpander>

          <CustomExpander>
            <div>סוג משוב</div>
            <div style={styles.dropdownContainer}>
              <Dropdown
                value={selectedPollId}
                options={globalSettingsStores.abstractPolls}
                onChange={(e) => setSelectedPollId(e.value)}
                optionLabel="pollName"
                optionValue="id"
                placeholder="בחר סוג משוב"
                showClear
                filter
                filterPlaceholder="חפש משוב..."
                style={{
                  width: '100%',
                  direction: 'rtl',
                }}
              />
            </div>
          </CustomExpander>
        </div>
        <div style={styles.buttonContainer}>
          <Button
            label="חפש"
            icon="pi pi-search"
            style={styles.searchButton}
            onClick={handleSearch}
          />
        </div>
      </div>
    );
  });
